import { Duration } from 'booking.lib.duration';

export const MaxInteractionBookingDurationsMs = 12 * Duration.getUnitDurations().H;
